import { useMatches } from 'react-router-dom';

import PotentialGraph from './PotentialGraph/PotentialGraph';
import TimelineGraph from './TimelineGraph/TimelineGraph';
import './graph-panel.css';

function GraphPanel() {
  const matches = useMatches();
  const routeHandle = matches[matches.length - 1]?.handle || {};

  if (routeHandle.showPotentialGraphPanel) {
    return <PotentialGraph />;
  }

  if (routeHandle.showTimelineGraphPanel) {
    return <TimelineGraph />;
  }

  return null;
}

export default GraphPanel;
